import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content mb-6 mt-8" }
const _hoisted_2 = { class: "password-tip" }
const _hoisted_3 = { class: "otp-container" }
const _hoisted_4 = ["onUpdate:modelValue", "type", "onInput", "onKeydown"]

import { ref, onMounted, nextTick } from "vue";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons-vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'OTPInput',
  props: {
  color: {
    type: String,
    default: "#4749ad", // 默认主题色
  },
},
  emits: ["update:code"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showPassword = ref(false);
const inputRefs = ref<(HTMLInputElement | null)[]>([]);
const codeArray = ref<string[]>(Array(6).fill(""));

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

// 关键修改3：暴露主动聚焦方法，供弹窗打开后调用
const focusFirstInput = () => {
  nextTick(() => {
    // 加少量延时兼容部分移动端机型
    setTimeout(() => {
      const firstInput = inputRefs.value[0];
      if (firstInput) {
        firstInput.focus();
        firstInput.click();
      }
    }, 100);
  });
};

// 组件挂载时的聚焦（非弹窗场景）
onMounted(() => {
  focusFirstInput();
});

const getFocusStyle = () => {
  return {
    "--focus-border-color": props.color,
  };
};

const handleInput = (index: number) => {
  // 确保输入的是数字
  codeArray.value[index] = codeArray.value[index].replace(/[^0-9]/g, "");

  // 自动跳到下一个输入框
  if (codeArray.value[index] && index < 5) {
    inputRefs.value[index + 1]?.focus();
  }

  emit("update:code", codeArray.value);
};

const handleKeydown = (event: KeyboardEvent, index: number) => {
  if (event.key === "Backspace" && !codeArray.value[index] && index > 0) {
    inputRefs.value[index - 1]?.focus();
  }
};

const handlePaste = (event: ClipboardEvent) => {
  event.preventDefault();
  const pastedText = event.clipboardData?.getData("text") || "";
  const numbers = pastedText
    .replace(/[^0-9]/g, "")
    .split("")
    .slice(0, 6);

  numbers.forEach((num, index) => {
    if (index < 6) {
      codeArray.value[index] = num;
    }
  });

  // 聚焦到最后一个填充的输入框的下一个，或第一个空输入框
  const lastFilledIndex = codeArray.value.findLastIndex((val) => val !== "");
  const focusIndex = Math.min(lastFilledIndex + 1, 5);
  inputRefs.value[focusIndex]?.focus();

  emit("update:code", codeArray.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, [
        _createElementVNode("i", null, "*"),
        _createTextVNode("请输入 6 位数字授权密码：")
      ], -1)),
      _createElementVNode("div", {
        class: "eye-icon",
        onClick: togglePassword
      }, [
        (showPassword.value)
          ? (_openBlock(), _createBlock(_unref(EyeOutlined), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(EyeInvisibleOutlined), { key: 1 }))
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("input", {
      type: "password",
      style: {"display":"none"},
      autocomplete: "new-password"
    }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, index) => {
        return _withDirectives(_createElementVNode("input", {
          key: index,
          ref_for: true,
          ref: (el) => (inputRefs.value[index] = el ? el as HTMLInputElement : null),
          "onUpdate:modelValue": ($event: any) => ((codeArray.value[index]) = $event),
          type: showPassword.value ? 'text' : 'tel',
          inputmode: "numeric",
          pattern: "[0-9]*",
          maxlength: "1",
          class: _normalizeClass(["otp-input", { 'password-hidden': !showPassword.value }]),
          style: _normalizeStyle(getFocusStyle()),
          onInput: ($event: any) => (handleInput(index)),
          onKeydown: ($event: any) => (handleKeydown($event, index)),
          onPaste: handlePaste,
          autocomplete: "one-time-code"
        }, null, 46, _hoisted_4), [
          [_vModelDynamic, codeArray.value[index]]
        ])
      }), 64))
    ])
  ]))
}
}

})